import templateUrl from './product-label-upload.html';

export default {
  templateUrl,
  bindings: {
    onProductLabelChanged: '&',
    labelText: '@',
    labelClass: '@',
    iconClass: '@',
    productId: '<',
    showPreview: '<',
    isAbbreviated: '<',
    buttonWidth: '@',
    locked: '<'
  },
  controller: class ProductLabelUploadComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, {
        EventEmitter
      });
    }

    onFileChanged(productLabel) {
      this.onProductLabelChanged(
        this.EventEmitter({
          productLabel,
          productId: this.productId
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/product-label-upload/product-label-upload.component.js